var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.sale.afip_tickets.length)?_c('div',{staticClass:"p-l-5"},_vm._l((_vm.sale.afip_tickets),function(afip_ticket){return _c('btn-factura',{staticClass:"m-l-5 m-b-10",attrs:{"print_url":_vm.print_url(afip_ticket),"afip_ticket":afip_ticket}})}),1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }